module.exports = __webpack_public_path__ + "assets/img/mecha-btn-6d72027c.png";